/**
 * Local Storage wrapper to prevent errors caused by window.localStorage not being available.
 */
export default class Storage {

    static getItem(key: string) {
        try {
            return localStorage.getItem(key)

        } catch {
            return null
        }
    }

    static setItem(key: string, value: any) {
        try {
            return localStorage.setItem(key, value)
        } catch { /* empty */ }
    }

    static removeItem(key: string) {
        try {
            return localStorage.removeItem(key)
        } catch { /* empty */ }
    }


    static getBoolean(key: string) {
        const value = this.getItem(key)

        if (value === null) {
            return null
        }

        return value == 'true' || value == '1'
    }

    static getTimestamp(key: string) {
        const value = this.getItem(key)

        return value ? Date.parse(value) : null
    }
}
